(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('RevisionReporteLibreService', RevisionReporteLibreService);

    RevisionReporteLibreService.$inject = ['$resource'];

    function RevisionReporteLibreService ($resource) {
        var resourceUrl =  'apo/revisionreporteli:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();
